import { createSlice } from "@reduxjs/toolkit";
import { changePasswordAPI } from "../../api/profile";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: data,
  reducers: {
   changePasswordSlice(state) {
      state.isLoading = true;
    },
   changePasswordSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    changePasswordSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    changePasswordSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const changePasswordHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(changePasswordAction.changePasswordSlice());
    const response: any = await changePasswordAPI(data);
    
    dispatch(changePasswordAction.changePasswordSliceSuccess(response));
  } catch (e: any) {
    dispatch(changePasswordAction.changePasswordSliceFailure(e?.response?.data));
  }
};
export default changePasswordSlice.reducer;
export const changePasswordAction = changePasswordSlice.actions;
